<template>
  <v-list v-bind="$attrs" v-on="$listeners">
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </v-list>
</template>

<script>
export default {
  name: "AList",
};
</script>

<style scoped>
::v-deep .v-list-item {
    background: #FFFFFF;
    border-width: 1px 0px;
    border-style: solid;
    border-color: var(--v-secondary-base);
    height: 58px;
    min-height: 58px;
    font-weight: 400;
    font-family: 'Noto Sans JP';
    font-size: 14px;
}
::v-deep .v-list-item__content {
  height: 42px !important;
  padding: 0;
  flex-basis: 88% !important;
}
.theme--light.v-list-item:not(.v-list-item--disabled) .v-list-item__title {
    font-size: 16px !important;
    color: var(--v-darkCharcoal-base) !important;
}
.theme--light.v-list-item:not(.v-list-item--disabled) .v-list-item__subtitle {
    font-size: 14px !important;
    color: var(--v-darkCharcoal-base) !important;
}

.theme--light.v-list-item:not(.v-list-item--disabled) .v-list-item__action-text {
  font-weight: 400 !important;
  font-size: 14px !important;
  color: var(--v-darkCharcoal-base) !important;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--disabled) .v-list-item__action-text {
  font-weight: 400 !important;
  font-size: 14px !important;
  /* margin-top: 2px; */
  margin-left: 2px;
}
::v-deep .theme--light.v-list-item:not(.v-list-item--active) .v-list-item__title {
    color: var(--v-darkCharcoal-base) !important;
    line-height: 21px !important;
}
::v-deep .theme--light.v-list-item:not(.v-list-item--active) .v-list-item__subtitle {
    color: var(--v-darkCharcoal-base) !important;
    line-height: 18px !important;
}
::v-deep .theme--light.v-list-item:not(.v-list-item--active) .v-list-item__action-text {
  color: var(--v-darkCharcoal-base) !important;
}
::v-deep .v-list-item__action {
    display: inline-flex;
    min-width: 36px !important;
    width: 36px !important;
    height: 24px !important;
    margin-right: 0 !important;
    margin-left: 16px !important;
}
::v-deep .v-list-item__icon {
    align-self: flex-start;
    margin: 0 !important;
}

::v-deep .v-list-item:hover {
    background: #EDF8FF !important;
    color: var(--v-darkCharcoal-base) !important;
}

::v-deep .theme--light.v-list-item--active {
    background: #006CAD !important;
    color: #FFFFFF !important;
    font-weight: 700 !important;
    /* line-height: 20px !important; */
}
::v-deep .theme--light.v-list-item--active .v-list-item__title {
    font-size: 16px !important;
    color: #FFFFFF !important;
    line-height: 23px !important;
}
::v-deep .theme--light.v-list-item--active .v-list-item__subtitle {
    font-size: 14px !important;
    color: #FFFFFF !important;
    line-height: 17px !important;
}
::v-deep .theme--light.v-list-item--active .v-list-item__action-text {
  color: #FFFFFF !important;
}
</style>